export default __webpack_public_path__ + "static/media/2407.6e38cac5.png";